import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { AlertService, ConfirmDialogService, ResourceService } from 'sce-core';
import { CoreServiceRegistry } from '../../../../core/core-service-registry';
import { DockDoorBookingDataService } from '../../../../features/outbound/dock-door-booking/dock-door-booking-home/services/dock-door-booking-data.service';
import { SharedServiceRegistry } from '../../../shared-service-registry';

@Component({
  selector: 'lfwms-generate-booking-popup',
  templateUrl: './generate-booking-popup.component.html',
  styleUrls: ['./generate-booking-popup.component.css']
})
export class GenerateBookingPopupComponent {

  private http$: HttpClient;
  private resourceService: ResourceService;
  protected confirmDialogService: ConfirmDialogService;
  private data: any;
  private dataService: DockDoorBookingDataService;
  private eventSubject = new Subject<any>();
  public item: any;
  public popupTitle: any;
  
  constructor(
    private coreServiceRegistry: CoreServiceRegistry,
    private sharedServiceRegistry: SharedServiceRegistry,
    private alertService: AlertService) {
    this.http$ = coreServiceRegistry.http$;
    this.resourceService = coreServiceRegistry.resourceService;
    this.confirmDialogService = sharedServiceRegistry.confirmDialogService;
  }

  initializeComponents(data: any) {
    this.data = data;
    this.item = this.data === 'generateAppointment'? 'lbl_an_appointment':'lbl_the_booking';
    this.popupTitle = this.data === 'generateAppointment'? 'lbl_gen_appointment':'lbl_gen_booking';
  }

  public notifyEvent(value: any) {
    this.eventSubject.next(value);
  }

  public receiveEvent(): Observable<any> {
    return this.eventSubject.asObservable();
  }
  // to get the display value of corresponding key from the resource bundle
  public getLabel(key: any) {
    return this.resourceService.get(key);
  }
  cancel() {
    this.sharedServiceRegistry.sceModalService.modalReference.hide();
  }
  generate(){
    this.cancel();
    this.notifyEvent({ type: this.data });
  }
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/lookup/dock-door-booking-popups/generate-booking-popup/generate-booking-popup.component.ts